import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MultiPickFromList from "../multiPickFromList/multiPickFromList";
import Modal from "react-modal";
import "./floatingForm.scss";
import Tree from "../tree/tree";

function CreateFloatingGroup(props) {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    document.getElementById("globalOverlay")?.addEventListener("click", () => {
      setModalOpen(false);
      //TODO: the same code executed in dashboardConfigurator
      document.getElementById("globalOverlay")?.classList.remove("active");
    });
  }, []);

  const toggleGlobalOverlay = () => {
    document.getElementById("globalOverlay")?.classList.toggle("active");
  };

  const onButtonClick = () => {
    setModalOpen(true);
    toggleGlobalOverlay();
  };

  const onReset = () => {
    props.itemWasChecked(props.defaultCheckedItems);
  };

  const closeModal = () => {
    setModalOpen(false);
    toggleGlobalOverlay();

    if (props.treeView) {
      onReset();
    }
  };

  function getParent() {
    return document.querySelector(props.module);
  }

  return (
    <span className="floating-form">
      <button className="floating-form-add-button buttonContent" onClick={onButtonClick}>
        <span className="plus">+</span>
      </button>
      <Modal
        ariaHideApp={false}
        parentSelector={getParent}
        className="floating-form-modal"
        overlayClassName="floating-form-overlay"
        isOpen={modalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick
        style={{
          content: props.treeView
            ? {
                height: props.modalHeight,
                maxWidth: props.modalMaxWidth,
                minWidth: props.modalMinWidth
              }
            : {
                width: props.modalWidth,
                height: props.modalHeight
              }
        }}
      >
        <div className="floating-form-content" data-testid="floatingGroupForm">
          <h3>{props.title}</h3>
          {props.treeView ? (
            <Tree
              data={props.checkList}
              selectedItems={props.selectedItems}
              checkList={props.checkList}
              itemWasChecked={props.itemWasChecked}
              maxDonuts={props.maxDonuts}
            />
          ) : (
            <MultiPickFromList
              hasPreLabel={props.hasPreLabel}
              checkList={props.checkList}
              defaultCheckedItems={props.defaultCheckedItems}
              selectHeight={props.selectHeight}
              modalWidth={props.modalWidth}
              itemWasChecked={props.itemWasChecked}
              maxDonuts={props.maxDonuts}
              maxChecked={props.maxChecked}
            />
          )}
          <div className={`floating-form-content-btn ${props.treeView ? "tree-view" : ""}`}>
            {props.treeView && (
              <button type="submit" className="reset" onClick={onReset}>
                Reset
              </button>
            )}
            <button
              type="submit"
              className="submit"
              onClick={() => {
                props.onSubmit({ checkedGroups: {}, groupName: "" });
                closeModal();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>
    </span>
  );
}

CreateFloatingGroup.propTypes = {
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  title: PropTypes.string,
  checkList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.any
    })
  ),
  defaultCheckedItems: PropTypes.object,
  onSubmit: PropTypes.func,
  selectHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  module: PropTypes.string,
  itemWasChecked: PropTypes.func,
  maxDonuts: PropTypes.number,
  maxChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  hasPreLabel: PropTypes.bool
};

export default CreateFloatingGroup;
